import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axiosInstance from "../../Services/AxiosAPICaller";
import '../../Features/Forms/Components/AccessSentMailPopUp/AccessSentMailPopUp.css';
import BackButton from "../../Components/BackButton/BackButton";


const AdminValidationSuccessPage: React.FC = () => {

    const location = useLocation();
    
    useEffect(() => {
      
        window.scrollTo(0, 0);
        const fetchData = async () => {

        const params = new URLSearchParams(location.search);
        const TargetMail = params.get('UserMail');

        // if a mail is found in the url we can send the login mail
        if (TargetMail) {

          //we first check if the user already exist
          const response = await axiosInstance.get(`/users?filters[$and][0][email][$eq]=${TargetMail}`);
          const UserAlreadyExist = response.data.length > 0;

          //if the user already exist we do nothing
          if (UserAlreadyExist) {
            console.log('User already exist');
            document.querySelector('.PopUpMessage')!.textContent = `Un utilisateur avec le mail : ${TargetMail} existe déjà. Aucunes autres opération n'a été effectuée, vous pouvez fermer cette page.`;
            return;
          }

          //if no users are found we create a new one by sending an authentication mail
          try {
            await axiosInstance.post('/passwordless/send-link', {
              email: TargetMail,
              username: TargetMail,
              context: {
                // context of authentification, optional parameter e.g. "currentUrl": "...my page..."
              }
            });
            console.log('Email sent successfully');
          } catch (error) {
            console.error('Error sending email:', error);
          }
        }

        // then we set the user as not blocked so he can access all the content
        try {
          const response = await axiosInstance.get('/users?filters[$and][0][email][$eq]=' + TargetMail);
          const UserId = response.data[0].id;
          try {
            await axiosInstance.put('/users/' + UserId, {
              blocked: false
            });
            console.log('User updated successfully');
          } catch (error) {
            console.error('Error updating user:', error);
          }
        } catch (error) {
          console.error('Error fetching user:', error);
        }
      };

      fetchData();
    }, [location]);
    

  return (
    <>
      <BackButton returnToHome={true} />
        <div className="PopUpDiv">
            <p className="PopUpMessage">Vous venez de valider une demande d'accès ! Un mail de connexion a été envoyé à l'utilisateur, vous pouvez maintenant retourner sur la page d'accueil.</p>
        </div>
    </>
  );
}

export default AdminValidationSuccessPage;
